module.exports = __webpack_public_path__ + "img/PL08475.ad9bf8f7.png";